import {
  Box,
  CircularProgress,
  circularProgressClasses,
  CircularProgressProps,
} from "@mui/material";
import { useIsMobile } from "src/hooks/useIsMobile";

export const StyledSpinner = (props: CircularProgressProps) => {
  const isMobile = useIsMobile();
  return (
    <Box sx={{ position: "relative" }}>
      <CircularProgress
        variant="determinate"
        size={isMobile ? 90 : 120}
        thickness={6}
        value={100}
        {...props}
      />
      <CircularProgress
        variant="indeterminate"
        disableShrink
        size={isMobile ? 90 : 120}
        thickness={6}
        sx={{
          color: "#ffffff",
          animationDuration: "1.2s",
          position: "absolute",
          left: 0,
          filter: `
            drop-shadow(0 0 6px rgba(255, 255, 255, 0.8))
            drop-shadow(0 0 12px rgba(255, 255, 255, 0.6))
          `,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        {...props}
      />
    </Box>
  );
};
